import React from "react";
import MirsTable from "components/general/table/Table";
import { useViewport } from 'components/general/useViewPort'
import CaptionTable from "components/general/table/CaptionTable";
import {
    TableColumnsSummary as ColumnsSummary,
    TableColumnsSummarySM as ColumnsSummarySM,
} from 'components/sports/bmx/summary/TableColumns'
import Label from "components/general/Label";

const getConfiguration = () => {
    let configuration = {
        caption: null,
        columns: [],
        hiddenColumns: [],
        sortBy: [],
    };

    configuration.caption = <CaptionTable
    leftCol={<h3 className="text-dark"><Label data={'LabelSummary'}/></h3>}
    />

    configuration.columns = ColumnsSummary()
    configuration.sortBy = [{ id: 'Rank', desc: false }]

    return configuration
}

const getConfigurationSM = () => {
    let configuration = {
        caption: null,
        columns: [],
        hiddenColumns: [],
        sortBy: [],
    };

    configuration.caption = <CaptionTable
    leftCol={<h3 className="text-dark"><Label data={'LabelSummary'}/></h3>}
    />

    configuration.columns = ColumnsSummarySM()
    configuration.sortBy = [{ id: 'Rank', desc: false }]

    return configuration
}

const BmxSummary = ({ data }) => {
    const { breakPoint } = useViewport();
    const rsc = data?.results?.eventUnitCode;

    const config = (breakPoint === "sm" || breakPoint === "xs") ? getConfigurationSM() : getConfiguration()

    return (
        <>
            {data?.items
                ? 
                <>
                    < MirsTable
                        //Dato to show by row
                        data={data?.items}
                        //Columnas a visualizar 
                        columns={config.columns}
                        caption={config.caption}
                        keyRow='participant-code'
                        sortable={false}
                        hiddenColumns={config.hiddenColumns}
                        initialSortBy={config.sortBy}
                        id={`mirs-table-result-${rsc}`}
                    />
                </>
                : ''
            }
        </>
    );
}

export default BmxSummary;